// region Languages
import useTranslation from "@languages/useTranslation";
import { AnnouncementMessages } from "@languages/interfaces";
// endregion Languages

/**
 * Spells an announcement's audience out in counts — "2 clientes · 1 pessoa" —
 * so the management listing and the form say the same thing about the same
 * announcement. Empty string when nobody is named yet.
 */
export const useReachLabel = () => {

  const { t } = useTranslation();

  return (tenants: number, users: number): string => {
    const parts: string[] = [];

    if (tenants === 1) parts.push(t(AnnouncementMessages.reachTenantOne));
    if (tenants > 1) parts.push(t(AnnouncementMessages.reachTenantMany, { count: tenants }));
    if (users === 1) parts.push(t(AnnouncementMessages.reachUserOne));
    if (users > 1) parts.push(t(AnnouncementMessages.reachUserMany, { count: users }));

    return parts.join(" · ");
  };
};
